import { render, staticRenderFns } from "./EditSvg.vue?vue&type=template&id=9e8502c8&"
import script from "./EditSvg.vue?vue&type=script&lang=js&"
export * from "./EditSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports